// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import UserIcon from './UserIcon';
import Menu from './Menu';

type Props = {
  username: string,
};

const UserMenu = (props: Props) => (
  <Menu
    id="user-menu"
    label={props.username}
    renderIcon={({ getProps }) => <UserIcon {...getProps()} />}
    renderItems={({ getProps }) => {
      return [
        <Link key="logout" to="/logout" {...getProps()}>
          Logout
        </Link>,
      ];
    }}
  />
);

export default UserMenu;



// WEBPACK FOOTER //
// ./src/pages/__components__/UserMenu.js